export const ADD_ACTION = 'addAction'
export const ADD_MULTIPLE_ACTIONS = 'addActions'
export const ADD_PENDING_ACTION = 'addPendingAction'
export const CLEAR_PENDING_ACTIONS = 'clearPendingActions'
export const SET_TIMEOUT = 'setTimeout'